import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeActivationSchedule: (value: string) => void;
}

export const ActivationScheduleInput: React.FC<IProps> = React.memo(({ changeActivationSchedule }) => (
	<FormInput
		testId="ActivationScheduleInput"
		name="activationSchedule"
		label="activationScheduleLabel"
		placeholder="cronExpressionInputPlaceholder"
		maxLength={255}
		onChange={changeActivationSchedule}
	/>
));
